module.exports = __webpack_public_path__ + "img/18.ff1c93c1.jpg";